module.exports = __webpack_public_path__ + "static/media/customer_gain.7c509f93.svg";